import { render, staticRenderFns } from "./DetailTelesale.vue?vue&type=template&id=07cc5f32&"
import script from "./DetailTelesale.vue?vue&type=script&lang=ts&"
export * from "./DetailTelesale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports